import Vue from 'vue'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Company2HubspotSelector',

  props: {
    configuration: Object,
    itemDTO: Object
  },

  data () {
    return {
      companyArray: [],
      dialog: false,
      searchCompany: '',
      selectedCompany: null
    }
  },

  computed: {
    ...mapGetters({
      loading: 'loaderStore/loading'
    })
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError',
      'startLoader': 'loaderStore/startLoader',
      'stopLoader': 'loaderStore/stopLoader'
    }),

    searchInHubspot () {
      this.startLoader({ id: 'hubspot-search' })
      const url = this.$axios.agilisUrlHubspotCompanySearch()
      const body = {}
      body.filters = [
        {
          value: `*${this.searchCompany.trim()}*`,
          propertyName: 'name',
          operator: 'CONTAINS_TOKEN'
        }
      ]
      body.limit = 100
      Vue.axios
        .post(
          url,
          body,
          Vue.axios.agilisRequestConfig(url))
        .then((response) => {
          this.companyArray = response.data
          this.$refs.selectCompany.isFocused = true
          this.$refs.selectCompany.isMenuActive = true
        })
        .catch((error) => {
          this.notifyError(error)
        }).finally(() => {
          this.stopLoader({ id: 'hubspot-search' })
        })
    },

    setCompany () {
      const url = this.$axios.agilisUrlHubspotCompany(this.selectedCompany.id)
      Vue.axios
        .get(
          url,
          {
            ...Vue.axios.agilisRequestConfig(url),
            params: {
              properties: this.getProperties().join(',')
            }
          })
        .then((response) => {
          this.mapPropertiesToField(response.data.properties)
        })
        .catch((error) => {
          this.notifyError(error)
        })
      this.closeDialog()
    },

    getProperties () {
      return this.configuration.hubspotCompanyMap.map(hubspot => { return hubspot.from })
    },

    mapPropertiesToField (properties) {
      Object.entries(properties).map(([key, value]) => {
        this.configuration.hubspotCompanyMap.map(hubspot => {
          if (hubspot.from === key) {
            if (hubspot.valueMap) {
              hubspot.valueMap.map(option => {
                if (option.from === value) {
                  this.itemDTO[hubspot.to] = option.to
                }
              })
            } else {
              this.itemDTO[hubspot.to] = value
            }
          }
        })
      })
    },

    closeDialog () {
      this.searchCompany = ''
      this.selectedCompany = null
      this.companyArray = []
      this.dialog = false
    }
  }
}
